import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Stack,
  useMediaQuery,
} from "@mui/material";
import { DarkLogo } from "../Common/assets/Sidebar";
import MenuIcon from "@mui/icons-material/MenuOutlined";
import { useAppSelector } from "../../Redux/hooks";

export const SurveyHeader = ({ logo, setShowDrawer, openPrintModal }: any) => {
  const isMobile = useMediaQuery("(max-width:900px)");
  const isDesktop = useMediaQuery("(min-width:900px)");
  const isFieldSubmitting = useAppSelector(
    (state) => state.response.fieldSubmitting
  );

  return (
    <Stack
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{
        height: "70px",
        px: 3,
        py: 2,
        border: { xs: "1px solid #E5E7EB", md: "none" },
        "& .header-logo": {
          maxWidth: "258px",
          maxHeight: "60px",
        },
        backgroundColor: "#FFF",
      }}
      gap={3}
    >
      {isMobile && (
        <IconButton
          aria-label="menu"
          size="large"
          onClick={() => setShowDrawer(true)}
        >
          <MenuIcon fontSize="inherit" />
        </IconButton>
      )}
      {logo?.url ? (
        <img
          src={logo?.previewUrl}
          alt="Logo 1"
          className="header-logo"
          loading="lazy"
        />
      ) : (
        <DarkLogo />
      )}

      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {isFieldSubmitting && <CircularProgress color="primary" size={24} />}
        {isDesktop && (
          <Button variant="contained" onClick={openPrintModal}>
            Print forms
          </Button>
        )}
      </Box>
    </Stack>
  );
};
